// Centralised date/time formatting — UK / Europe/London (BST when applicable).
// DST is handled automatically by the browser's Intl + IANA "Europe/London" tz id.
//
// formatDate("2026-03-10")            → "10 Mar 2026"
// formatDate("2026-03-10T09:30:00Z")  → "10 Mar 2026"
// formatDateTime("2026-03-10T09:30Z") → "10 Mar 2026, 09:30 BST"  (or GMT in winter)
// formatTime("2026-03-10T09:30:00Z")  → "09:30 BST"

const TZ = "Europe/London";

function _safeDate(input) {
  if (!input) return null;
  // Bare YYYY-MM-DD strings: parse as local midnight so they don't shift across timezones.
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
    const [y, m, d] = input.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(input);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDate(input, opts = {}) {
  const d = _safeDate(input);
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: opts.bareDateOnly ? undefined : TZ,
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);
}

export function formatDateTime(input) {
  const d = _safeDate(input);
  if (!d) return "—";
  // Use timeZoneName: "short" → renders BST in summer, GMT in winter
  const formatted = new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
    hour12: false,
  }).format(d);
  return formatted;
}

export function formatTime(input) {
  const d = _safeDate(input);
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ,
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
    hour12: false,
  }).format(d);
}

/** ISO YYYY-MM-DD using the Europe/London calendar (i.e. respects BST). */
export function todayISO() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
}
